import { $subscriber, URLS } from "fire-wind-water";
// import setting from "@/sktempjson/template-pc.json";
import service from "../services/article";
import { $extras, $messageLoad } from "@/../stempcore/src/core/sextra.js";
import { isSetting } from "../common/sbase";

let mixin = {
  data() {
    return {
      extras: {},
      isSetting: URLS.getURL("isSetting")
    };
  },
  methods: {
    initConfig(configId, tenantId) {
      if (!isSetting) {
        let param = {
          configId: configId,
          tenantId: tenantId
        };
        service.getConfig(param).subscribe(data => {
          if (data.result == 0) {
            this.extras = $extras(data.content.info.html).extras;

            $subscriber.emit("config-loaded", this.extras);
            if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
              let themeColorClear = "";
              const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
              if (rgbaAttr.length >= 3) {
                let r, g, b;
                r = rgbaAttr[0];
                g = rgbaAttr[1];
                b = rgbaAttr[2];
                themeColorClear =
                  "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
              }

              document.body.style.setProperty(
                "--themeColor",
                this.extras.themecolor.bgcolor
              );
              document.body.style.setProperty(
                "--themeColorClear",
                themeColorClear
              );
            }
          }
        });
      }
    }
  },
  created() {
    console.log("# subscribe 'sk-template-config'.");
    $subscriber.subscribe("sk-template-config", o => {
      console.log("# catch 'sk-template-config' ...");
      // console.log("# o.data: ", JSON.stringify(o.data));
      this.extras = $extras(o.data).extras;
      if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
        let themeColorClear = "";
        const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
        if (rgbaAttr.length >= 3) {
          let r, g, b;
          r = rgbaAttr[0];
          g = rgbaAttr[1];
          b = rgbaAttr[2];
          themeColorClear = "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
        }

        document.body.style.setProperty(
          "--themeColor",
          this.extras.themecolor.bgcolor
        );
        document.body.style.setProperty("--themeColorClear", themeColorClear);
      }
      $subscriber.emit("config-loaded", this.extras);
    });
  },
  mounted() {
    console.log("# $messageLoad ...");
    $messageLoad(1);
  }
};

export default mixin;
